<template>
  <div class="bottom">
    <div class="container">
      <div class="content">
        <p>Copyright © 2024 安徽科学技术出版社 版权所有</p>
        <p>地址：安徽省·合肥市·蜀山区·翡翠路1118号出版传媒广场9楼 邮编：230071</p>
        <p>读者咨询服务热线：0551-63533323 会员管理电话：0551-635333323</p>
        <p>图文传真：0551-63533300 反盗版举报电话：0551-63533315 总机：0551-63533388、63533399</p>
        <p>网络文化经营许可证编号：皖网文（2024）2007-023号</p>
        <!-- <p style="-moz-margin-top:-10px;-moz-background-color: red;"><a href="http://beian.miit.gov.cn/" target="_blank" style="display:inline-block;text-decoration:none; color:#666;">© 乐龄听书 皖B2-20130027-8</a><img style="width:18px; height:18px;" class="icon" src="../../assets/gongan.png">  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402701762" style="color:#666;display:inline-block;text-decoration:none;">皖公网安备 34010402701762号</a></p>    -->
        <p style="margin-top: -2px">
          <span
            ><a
              href="http://beian.miit.gov.cn/"
              target="_blank"
              style="display: inline-block; text-decoration: none; color: #666"
              >© 乐龄听书 皖B2-20130027-8</a
            ></span
          >
          <img
            style="width: 16px; height: 16px"
            class="icon"
            src="../../assets/gongan.png"
          />
          <span
            ><a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402701762"
              style="color: #666; display: inline-block; text-decoration: none"
              >皖公网安备 34010402701762号</a
            ></span
          >
        </p>
      </div>

      <div class="contentSecond">
        <p>
          <a
            href="https://jbts.mct.gov.cn/home"
            target="_blank"
            style="display: inline-block; text-decoration: none; color: #666"
            >全国文化和旅游市场网上举报投诉电话: 12345</a
          >
        </p>
        <p>邮箱投诉: lltsshfw@163.com</p>
        <p>纠纷处理联系电话: 0551-63533388 转1069</p>
      </div>

      <div class="qrCode">
        <img src="../../assets/gzhCode.png" />
        <p>关注公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.bottom {
  height: 230px;
  width: 100%;
  background-color: rgb(243, 243, 243);
}

.bottom .container {
  height: 230px;
  width: 1200px;
  // background-color: rgb(243, 243, 243);
  margin: 0 auto;
}

.bottom .container .content {
  float: left;
  margin-left: 20px;
  margin-top: 25px;
}

.bottom .container .content p {
  font-size: 14px;
  color: #666666;
  line-height: 14px;
}

.contentSecond {
  float: left;
  margin-left: 63px;
  margin-top: 27px;
  width: 290px;
  height: 100px;
}

.contentSecond p {
  font-size: 14px;
  color: #666666;
  line-height: 14px;
}

.bottom .container .qrCode {
  float: right;
  margin-right: 20px;
  width: 100px;
  height: 120px;
  margin-top: 45px;
}

.bottom .container .qrCode p {
  text-align: center;
  font-size: 12px;
  color: #333333;
  margin-top: 4px;
}

.icon {
  margin: 0 5px;
  vertical-align: bottom;
}
</style>
